import {orgList} from "../../../actions/orgList";
import {
    setDefaultOrbit,
    setDiagnosticFilterList,
    setDiagnosticId,
    setDiagnosticList,
    setDisplayDiagnostics,
    setDisplayOrbit,
    setDisplayOrganization,
    setDisplayServiceLine,
    setDisplayTiles,
    setHideTopNav,
    setHome,
    setInitialTopNavDisplay,
    setOrbitList,
    setOrganizationId,
    setOrganizationList,
    setServiceLineId,
    setServiceLineList,
    setTermsConditionsCompleted,
    setViewedWelcomeMessage,
    setWelcomeMessage
} from "../../../actions/home";
import {orbit} from "../../../actions/orbit";
import {getServiceLineList} from "../../../actions/serviceLineList";
import {orbitClusterTileList} from "../../../actions/orbitClusterTileList";
import {HOME, UPDATE_LOGO} from "../../../actions/types";
import {ORBIT_ADMIN, ORGANIZATION_ADMIN, REGULAR_USER, SERVICE_LINE_ADMIN, SYS_ADMIN} from "../../../constants/roles";
import {setUser} from "../../../helpers/index";
import {orbitById} from "../../../actions/orbitById";
import {updateFavIconAttributes} from "../favIconAttributes/index";

export const setOrganization = (dispatch) => (setTermsConditionsCompleted) => {
    return (user) => {
        return (setDisplayCluster) => {
            return (setIsLoadingServiceLine) => {
                return (organizationList) => {
                    // You can make this inner function async if needed
                    return async (value) => {
                        debugger;
                        dispatch(setOrganizationId(value));

                        if (user?.isSysAdmin) {
                            debugger;
                            debugger;
                            user.organizationId = value;
                            setUser(user);
                        }

                        debugger;
                        if (organizationList && organizationList.length > 1) {
                            debugger;
                            const selectedOrganization = user?.organizations?.find((org) => org.organizationId === value);
                            const selectedOrbitOrg = !selectedOrganization
                                ? user?.orbits?.find((orbit) => orbit.organizationId === value)
                                : null;
                            debugger;
                            if (user?.organizations && user?.organizations?.length > 0 && selectedOrganization) {
                                debugger;
                                debugger;
                                user.organizationId = selectedOrganization.organizationId;
                                user.roles = selectedOrganization.roles;
                                user.diagnoses = selectedOrganization.diagnoses;
                                dispatch(setViewedWelcomeMessage(user?.organizations[0]?.viewedWelcomeMessage ?? false));
                                dispatch(setWelcomeMessage(user?.organizations[0]?.welcomeMessage ?? null));
                                setUser(user);
                                setTermsConditionsCompleted(!selectedOrganization.termsConditionsCompleted);
                            } else if (selectedOrbitOrg) {
                                user.organizationId = selectedOrbitOrg.organizationId;
                                user.roles = selectedOrbitOrg.roles;
                                user.diagnoses = selectedOrbitOrg.diagnoses;
                                setUser(user);
                                // T&C deferred to orbit selection in setValue — no defaultOrbit yet
                            }

                            dispatch(setDisplayTiles(false));
                            dispatch(setInitialTopNavDisplay(false));
                            dispatch(setDisplayOrganization(false));
                            dispatch(setDisplayServiceLine(false));
                            setDisplayCluster(false);
                            dispatch(setDisplayOrbit(true));
                            dispatch(setHideTopNav(true));
                            dispatch(setHome({
                                tileAttributes: null,
                                clusterCssArray: null,
                                clusterType: 0,
                                useFlexContainer: null
                            }));
                            setIsLoadingServiceLine(true);
                            if (selectedOrganization?.serviceLines && selectedOrganization?.serviceLines?.length > 0)
                                loadServiceList(dispatch)({organizationId: value});
                            else
                                loadServiceList(dispatch)({organizationId: value});
                        } else {
                            const organization = user?.organizations?.find((org) => org.organizationId === value)
                                || user?.orbits?.find((orbit) => orbit.organizationId === value);
                            debugger;
                            debugger;
                            if (organization) {
                                user.organizationId = organization.organizationId;
                                user.roles = organization.roles;
                                user.diagnoses = organization.diagnoses;
                                setUser(user);
                            }
                            if (organization?.serviceLines && organization?.serviceLines?.length > 0)
                                loadServiceList(dispatch)({organizationId: value});
                            else
                                loadServiceList(dispatch)({organizationId: value});
                        }
                    };
                };
            };
        };
    };
};

export const setServiceLine = (dispatch) => {
    return (serviceLineList) => {
        return (setIsLoadingOrbit) => {
            return (defaultOrbit) => {
                return (user) => {
                    return async (value) => {
                        debugger;
                        dispatch(setServiceLineId(value));
                        dispatch(setHome({
                            tileAttributes: null,
                            clusterCssArray: null,
                            clusterType: 0,
                            useFlexContainer: null
                        }));
                        if ((serviceLineList && serviceLineList.length > 1) && (!defaultOrbit || defaultOrbit.length === 0)) {
                            dispatch(setDisplayTiles(false));
                            setIsLoadingOrbit(true);
                            loadOrbitList(dispatch)({organizationId: user?.organizationId, serviceLineId: value});
                        } else {
                            loadOrbitList(dispatch)({organizationId: user?.organizationId, serviceLineId: value});
                        }
                    }
                }
            }
        }
    }
}

export const setValue = (dispatch) => (setTermsConditionsCompleted) => {
    return (navigate) => {
        return (location) => {
            return (setHasLoadedTiles) => {
                return (setIsRegularUserSettingsComplete) => {
                    return (isRegularUserSettingsComplete) => {
                        return (user) => {
                            return async (value) => {
                                dispatch(setDisplayOrbit(false));
                                dispatch(setDefaultOrbit(value));
                                user.defaultOrbit = value;
                                setUser(user);

                                const orb = await orbitById({orbitId: value}, async (data) => {
                                    //setList(data);
                                    debugger;
                                    if ((!user?.organizations || user?.organizations?.length === 0) &&
                                        user?.orbits && user?.orbits?.length > 0) {
                                        const orbit = user?.orbits.find((orbit) => orbit.orbitId === value);
                                        if (orbit) {
                                            user.organizationId = orbit.organizationId;
                                            user.roles = orbit.roles;
                                            user.relation = orbit.relation;
                                            user.diagnoses = orbit.diagnoses;
                                            setTermsConditionsCompleted(!orbit.termsConditionsCompleted);
                                            setUser(user);
                                            if (user?.roles?.includes(REGULAR_USER) && !isRegularUserSettingsComplete) {
                                                setIsRegularUserSettingsComplete(true);
                                                dispatch(setDisplayTiles(true));
                                                dispatch(setDisplayDiagnostics(false));
                                                setHasLoadedTiles(true);
                                            } else if (user?.roles?.includes(ORBIT_ADMIN)) {
                                                dispatch(setDisplayTiles(true));
                                                dispatch(setDisplayDiagnostics(false));
                                                setHasLoadedTiles(true);
                                            }
                                        }
                                    }

                                    if (user?.organizations && user?.organizations?.length > 0) {
                                        user.selectedOrbit = value;
                                        dispatch(setViewedWelcomeMessage(user?.orbits[0]?.viewedWelcomeMessage ?? false));
                                        dispatch(setWelcomeMessage(user?.orbits[0]?.welcomeMessage ?? null));

                                        // Find the organization that contains the selected orbit
                                        // Use data.organizationId from the orbitById API response as the authoritative source
                                        let organization = user?.organizations.find((org) => org.organizationId === data.organizationId)
                                            || user?.organizations.find((org) => org.organizationId === user?.organizationId);

                                        if (!organization && user?.orbits) {
                                            const orbitMatch = user.orbits.find((o) => o.orbitId === value);
                                            if (orbitMatch) {
                                                user.organizationId = orbitMatch.organizationId;
                                                user.roles = orbitMatch.roles;
                                                user.diagnoses = orbitMatch.diagnoses;
                                                setTermsConditionsCompleted(!orbitMatch.termsConditionsCompleted);
                                                setUser(user);
                                            }
                                        } else if (organization) {
                                            user.organizationId = organization.organizationId;
                                            user.roles = organization.roles;
                                            setTermsConditionsCompleted(!organization.termsConditionsCompleted);
                                            setUser(user);
                                        }
                                    }

                                    dispatch({type: UPDATE_LOGO, payload: {favIconAttributes: data.favIconAttributes, orgImageUrl: data.imageUrl, orbitCssClass: data.cssClass}});
                                    updateFavIconAttributes(data.imageUrl, data.cssClass, data.favIconAttributes);

                                    navigate(location.pathname);
                                }, 'orbit');
                                await dispatch(orb);
                            }
                        }
                    }
                }
            }
        }
    }
}

export const showHideByUserTypeForOrganization = (dispatch) => (userType) => {
    if (userType.includes(SERVICE_LINE_ADMIN)) {
        dispatch(setDisplayTiles(false));
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(false));
        dispatch(setHideTopNav(true));
    } else if (userType.includes(ORGANIZATION_ADMIN)) {
        dispatch(setDisplayTiles(false));
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(false));
        dispatch(setHideTopNav(true));
    } else if (userType.includes(SYS_ADMIN)) {
        dispatch(setDisplayTiles(false));
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(false));
        dispatch(setHideTopNav(true));
    } else if (userType.includes(ORBIT_ADMIN)) {
        dispatch(setDisplayTiles(false));
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(false));
        dispatch(setHideTopNav(true));
    }
}

export const showHideByUserTypeForOrbit = (dispatch) => (userType) => {
    if (userType.includes(REGULAR_USER)) {
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayTiles(false));
        dispatch(setDisplayOrganization(false));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(true));
        dispatch(setHideTopNav(true));
    } else {
        dispatch(setInitialTopNavDisplay(false));
        dispatch(setDisplayTiles(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(true));
        dispatch(setHideTopNav(true));
    }
}

export const loadOrganization = (dispatch) => (user) => {
    (async () => {
        const ol = await orgList({}, (data) => {
            dispatch(setOrganizationList(data?.organizations?.map((organization) => ({
                organizationId: organization.organizationId,
                orgName: organization.orgName
            }))));
            showHideByUserTypeForOrganization(dispatch)(user.roles);
        });

        await dispatch(ol);
    })()
}

export const loadOrbitList = (dispatch) => (dataToSubmit) => {
    (async () => {
        const orb = await orbit(dataToSubmit, async (data) => {
            if (!data.errors && data?.orbits && data?.orbits?.length > 0)
                dispatch(setOrbitList(data?.orbits));
            else
                dispatch(setOrbitList([]));

            dispatch(setInitialTopNavDisplay(false));
            dispatch(setDiagnosticList([]));
            dispatch(setDiagnosticFilterList([]));
            dispatch(setDisplayServiceLine(false));
            dispatch(setDisplayOrganization(false));
            dispatch(setDisplayTiles(false));
            dispatch(setDisplayDiagnostics(false));
            dispatch(setDisplayServiceLine(false));
            dispatch(setDisplayOrbit(true));
        });
        await dispatch(orb);
    })();
}

export const loadServiceList = (dispatch) => (dataToSubmit) => {
    (async () => {
        const orb = await getServiceLineList(dataToSubmit, async (data) => {
            if (!data.errors && (data && data.items && data.items.length > 0)) {
                dispatch(setServiceLineList(data.items));
            } else {
                dispatch(setServiceLineList([]));
            }

            if (data && data.items && data.items.length === 1) {
                dispatch(setInitialTopNavDisplay(false));
                dispatch(setDisplayServiceLine(false));
                dispatch(setDiagnosticList([]));
                dispatch(setDiagnosticFilterList([]));
                dispatch(setServiceLineId(data.items[0].serviceLineId));
                loadOrbitList(dispatch)({organizationId: dataToSubmit.organizationId, serviceLineId: data.items[0].serviceLineId});
            } else if (data && data.items && data.items.length > 1) {
                dispatch(setInitialTopNavDisplay(false));
                dispatch(setDisplayServiceLine(true));
                dispatch(setDiagnosticList([]));
                dispatch(setDiagnosticFilterList([]));
                dispatch(setOrbitList([]));
                /*
                if (!data.items.some(item => item["name"] === 'Do not filter'))
                    data.items.push({serviceLineId: '', name: 'Do not filter'});
                 */
                dispatch(setServiceLineList(data.items));
            } else {
                dispatch(setDisplayServiceLine(false));
                dispatch(setInitialTopNavDisplay(false));
                dispatch(setDiagnosticList([]));
                dispatch(setDiagnosticFilterList([]));
                dispatch(setServiceLineList([]));
                loadOrbitList(dispatch)({organizationId: dataToSubmit.organizationId})
            }
        });
        await dispatch(orb);
    })();
}

export const loadTiles = (user) => (setProfileUrl) => (dispatch) => (dataToSubmit) => {
    (async () => {
        //const user =
        dispatch(setDisplayTiles(false));
        dispatch(setDisplayOrbit(false));
        const ca = await orbitClusterTileList(dataToSubmit, HOME, async (data) => {
            if (data && data.tileAttributes && data.tileAttributes.length > 0) {
                dispatch(setHome(data));
                dispatch(setDisplayServiceLine(false));
                dispatch(setDisplayOrganization(false));
                dispatch(setDisplayOrganization(false));
                dispatch(setDisplayTiles(true));
                dispatch(setHideTopNav(false));
                setProfileUrl(user?.imageUrl);
            }
            //setDisplayCluster(true);
        });
        await dispatch(ca);
    })()
}

export const userHasMultipleOrganizations = (dispatch) => (user) => (setOrganizationList) => {
    dispatch(setOrganizationList(user?.organizations.map((organization) => ({
        organizationId: organization.organizationId,
        orgName: organization.orgName
    }))));
    dispatch(setDisplayTiles(false));
    dispatch(setDisplayOrganization(true));
    dispatch(setDisplayServiceLine(false));
    dispatch(setDisplayOrbit(false));
    dispatch(setHideTopNav(false));
    dispatch(setInitialTopNavDisplay(false));
}

export const userHasSingleOrganization = (dispatch) => (setTermsConditionsCompleted) => async (user)  => {
    dispatch(setOrganizationId(user?.organizations[0].organizationId));
    await setOrganization(dispatch)(user?.organizations[0].organizationId)
    debugger;
    debugger;
    user.organizationId = user?.organizations[0].organizationId;
    user.roles = user?.organizations[0].roles;
    user.diagnoses = user?.organizations[0].diagnoses;
    dispatch(setViewedWelcomeMessage(user?.organizations[0]?.viewedWelcomeMessage ?? false));
    dispatch(setWelcomeMessage(user?.organizations[0]?.welcomeMessage ?? null));
    setUser(user);
    showHideByUserTypeForOrganization(user.roles);
    const organization = user?.organizations[0];
    if (organization?.serviceLines && organization?.serviceLines?.length > 0)
        loadServiceList(dispatch)({organizationId: user.organizationId});
    else
        loadServiceList(dispatch)({organizationId: user.organizationId});
    setTermsConditionsCompleted(!user?.organizations[0].termsConditionsCompleted);
}

export const userIsSysAdmin = (dispatch) => (user) => {
    user.roles = [4];
    setUser(user);
    loadOrganization(dispatch)(user);
}

export const userHasMultipleOrbits = (dispatch) => (user) => {
    dispatch(setOrbitList(user?.orbits.map((orbit) => ({
        orbitId: orbit.orbitId,
        orbitName: orbit.name,
        orgName: orbit.orgName
    }))));
    dispatch(setDisplayOrbit(true));
    dispatch(setDisplayTiles(false));
    dispatch(setDisplayOrganization(false));
    dispatch(setDisplayServiceLine(false));
    dispatch(setInitialTopNavDisplay(false));
}

export const userHasSingleOrbit = (dispatch) => (setTermsConditionsCompleted) => (user) => {
    dispatch(setDefaultOrbit(user?.orbits[0].orbitId));
    debugger;
    debugger;
    user.organizationId = user?.orbits[0].organizationId;
    user.roles = user?.orbits[0].roles;
    user.defaultOrbit = user?.orbits[0].orbitId;
    user.relation = user?.orbits[0].relation;
    user.diagnoses = user?.orbits[0].diagnoses;
    dispatch(setViewedWelcomeMessage(user?.orbits[0]?.viewedWelcomeMessage ?? false));
    dispatch(setWelcomeMessage(user?.orbits[0]?.welcomeMessage ?? null));
    setUser(user);
    dispatch({type: UPDATE_LOGO, payload: {favIconAttributes: user?.orbits[0].favIconAttributes, orgImageUrl: user?.orbits[0].imageUrl, orbitCssClass: user?.orbits[0].cssClass}});
    updateFavIconAttributes(user?.orbits[0].imageUrl, user?.orbits[0].cssClass, user?.orbits[0].favIconAttributes);
    showHideByUserTypeForOrbit(user.roles);
    setTermsConditionsCompleted(!user?.orbits[0].termsConditionsCompleted);
}

export const getAllDistinctOrganizations = (user) => {
    const orgMap = new Map();
    if (user?.organizations) {
        user.organizations.forEach((org) => {
            orgMap.set(org.organizationId, {
                organizationId: org.organizationId,
                orgName: org.orgName,
            });
        });
    }
    if (user?.orbits) {
        user.orbits.forEach((orbit) => {
            if (!orgMap.has(orbit.organizationId)) {
                orgMap.set(orbit.organizationId, {
                    organizationId: orbit.organizationId,
                    orgName: orbit.orgName,
                });
            }
        });
    }
    return Array.from(orgMap.values());
};

export const userOrbitOrgPopulateAndDisplay = (dispatch) => (setTermsConditionsCompleted) => (user) => (organizationList) => (organizationId)   => {
    const allDistinctOrgs = getAllDistinctOrganizations(user);

    if (user?.isSysAdmin &&
        (!organizationId || organizationId.length === 0) &&
        (!organizationList || organizationList.length === 0)) {
        userIsSysAdmin(dispatch)(user);
    } else if (allDistinctOrgs.length > 1 &&
        (!organizationList || organizationList.length === 0)) {
        // Multiple distinct orgs (from organizations and/or orbits) — show org picker
        dispatch(setOrganizationList(allDistinctOrgs));
        dispatch(setDisplayTiles(false));
        dispatch(setDisplayOrganization(true));
        dispatch(setDisplayServiceLine(false));
        dispatch(setDisplayOrbit(false));
        dispatch(setHideTopNav(false));
        dispatch(setInitialTopNavDisplay(false));
    } else if (allDistinctOrgs.length === 1 &&
        (!organizationId || organizationId.length === 0)) {
        // Single distinct org — auto-select
        if (user?.organizations && user?.organizations?.length === 1) {
            userHasSingleOrganization(dispatch)(setTermsConditionsCompleted)(user);
        } else if (user?.orbits && user?.orbits?.length === 1) {
            userHasSingleOrbit(dispatch)(setTermsConditionsCompleted)(user);
        } else if (user?.orbits && user?.orbits?.length > 1) {
            // Multiple orbits but all same org — show orbit list
            userHasMultipleOrbits(dispatch)(user);
        }
    } else if (allDistinctOrgs.length === 0 &&
        user?.orbits && user?.orbits?.length > 0) {
        // Orbits only, no organizations
        if (user.orbits.length > 1) {
            userHasMultipleOrbits(dispatch)(user);
        } else {
            userHasSingleOrbit(dispatch)(setTermsConditionsCompleted)(user);
        }
    } else if (user?.isSysAdmin ||
        user?.roles?.includes(ORGANIZATION_ADMIN) ||
        user?.roles?.includes(SYS_ADMIN) ||
        user?.roles?.includes(SERVICE_LINE_ADMIN)) {
        dispatch(setDisplayOrbit(true));
    }
}

export const setDiagnosticValue = (dispatch) => (value) => {
    dispatch(setDisplayTiles(true));
    dispatch(setDiagnosticId([value]));
    dispatch(setDisplayDiagnostics(false));
    dispatch(setInitialTopNavDisplay(true));
}
